import axios from "axios";
import { toast } from "react-toastify";
import { NuevaAPICobranza } from "../Constants/ApiConnection";

export const postcrearCalendarioDePagos = async (user, values) => {
  let url = NuevaAPICobranza + "contratos/crearCalendarioPagos/";
  try {
    const response = await axios.post(url, values, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};

export const getcrearCalendarioDePagos = async (user, values) => {
  let url = NuevaAPICobranza + "contratos/obtenerCalendarioPagos/" + values;
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};
